<template>
  <CMenu ref="menu">
    <template v-slot:activator>
      <CButton icon="more_vert" round />
    </template>

    <template v-slot:content>
      <CItemLabel header>
        {{ $t('Export') }}
      </CItemLabel>

      <CList>
        <CItem clickable @click="onClickData">
          <CItemSection>
            <CItemLabel>{{ $t('Export data') }}</CItemLabel>
            <CItemLabel caption>
              {{ $t('File type: {type}', { type: exportDataType }) }}
            </CItemLabel>
          </CItemSection>
        </CItem>

        <CItem clickable @click="onClickImage">
          <CItemSection>
            <CItemLabel>{{ $t('Export image') }}</CItemLabel>
            <CItemLabel caption>
              {{ $t('File type: {type}', { type: exportImageType }) }}
            </CItemLabel>
          </CItemSection>
        </CItem>
      </CList>

      <CSeparator spaced />

      <CItemLabel header>
        {{ $t('Preferences') }}
      </CItemLabel>

      <CList>
        <CItem clickable @click="onClickChartPreferences">
          <CItemSection>
            <CItemLabel>{{ $t('Chart settings') }}</CItemLabel>
          </CItemSection>
        </CItem>
      </CList>
    </template>
  </CMenu>
</template>

<script>
import Vue from 'vue';
import CMenu from '@/components/uikit/CMenu';
import CList from '@/components/uikit/CList';
import CItem from '@/components/uikit/CItem';
import CItemSection from '@/components/uikit/CItemSection';
import CItemLabel from '@/components/uikit/CItemLabel';
import CButton from '@/components/uikit/CButton';
import CSelector from '@/components/uikit/CSelector';
import CSeparator from '@/components/uikit/CSeparator';

const messages = {
  en: {
    Export: 'Export',
    'Export data': 'Export Data',
    'Export image': 'Export Image',
    'File type: {type}': '{type} File',
    Preferences: 'Preferences',
    'Chart settings': 'Chart Settings',
  },
  ja: {
    Export: 'エクスポート',
    'Export data': 'データをエクスポート',
    'Export image': 'イメージをエクスポート',
    'File type: {type}': 'ファイルタイプ: {type}',
    Preferences: '環境設定',
    'Chart settings': 'チャートの設定',
  },
};

export default Vue.extend({
  name: 'ActionMenu',
  i18n: { messages },
  components: {
    CItemLabel,
    CItemSection,
    CItem,
    CList,
    CMenu,
    CButton,
    CSelector,
    CSeparator,
  },
  props: {
    conditions: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    exportDataType() {
      return this.conditions.exportDataType ? this.conditions.exportDataType.toUpperCase() : '-';
    },
    exportImageType() {
      return this.conditions.exportImageType ? this.conditions.exportImageType.toUpperCase() : '-';
    },
  },
  methods: {
    onClickData() {
      this.$emit('export-data');
    },

    onClickImage() {
      this.$emit('export-image');
    },

    onClickChartPreferences() {
      this.$emit('click-chart-preferences');
    },
  },
});
</script>
